import axios from "axios";
import axiosInstance from "./axiosInstance";

const queryString = require("query-string");

class CargoColegiadoApi {
  cancelTokens = {
    getCargoColegiado: null,
    getCargosColegiados: null,
    setCargoColegiado: null,
    destroyCargoColegiado: null,
  };

  isCancel(exceptionThrown) {
    return axios.isCancel(exceptionThrown);
  }

  async destroyCargoColegiado(cargoColegiadoId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.destroyCargoColegiado = source;

    const { data } = await axiosInstance.delete(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/cargos_colegiados/${cargoColegiadoId}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.destroyCargoColegiado = null;
    return data;
  }

  async setCargoColegiado(cargoColegiado) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.setCargoColegiado = source;

    if (cargoColegiado.id) {
      const { data } = await axiosInstance.put(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/cargos_colegiados/${cargoColegiado.id}`,
        cargoColegiado,
        {
          cancelToken: source.token,
        }
      );

      this.cancelTokens.setCargoColegiado = null;
      return data;
    } else {
      const { data } = await axiosInstance.post(
        `${process.env.VUE_APP_BASE_API_URL}/api/v1/cargos_colegiados`,
        cargoColegiado,
        {
          cancelToken: source.token,
        }
      );

      this.cancelTokens.setCargoColegiado = null;
      return data;
    }
  }

  async getCargosColegiados({ page = 1, qtd_por_pagina, nome }) {
    const query = queryString.stringify({
      page,
      qtd_por_pagina,
      nome,
    });

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getCargosColegiados = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/cargos_colegiados?${query}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getCargosColegiados = null;

    return data;
  }

  async getCargoColegiado(cargoColegiadoId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getCargoColegiado = source;

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/cargos_colegiados/${cargoColegiadoId}`,
      {
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getCargoColegiado = null;

    return data;
  }
}

export default CargoColegiadoApi;